import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=4804c9fd&scoped=true&"
import script from "./FormBuilder.vue?vue&type=script&lang=ts&"
export * from "./FormBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./FormBuilder.vue?vue&type=style&index=0&id=4804c9fd&prod&scoped=true&lang=css&"
import style1 from "./FormBuilder.vue?vue&type=style&index=1&id=4804c9fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804c9fd",
  null
  
)

export default component.exports